<template>
  <vue-flashcard
    front="STARFIT (SWIFT)"
    back="iPhone application's purpose is to keep track of user's daily caloric intake.
          Displays user's daily and weekly average calories.
          Demonstrated ability to write software for a functional application."
    headerFront=''
    headerBack=''
    footerFront=''
    footerBack=''>
  </vue-flashcard>
</template>

<script>
import vueFlashcard from 'vue-flashcard';

export default {
  components : {
    vueFlashcard
  }
}
</script>


// WEBPACK FOOTER //
// src/components/StarFit.vue